import { getResource } from './BaseRequests'

export const fetchPurchases = (success, fail) => {
    getResource("purchases", {}, 60).then(success).catch(fail)
}